<template>
  <div>
    <HeaderVue />
    <v-container fluid class="py-0" :class="{ 'mt-16': isMobile, 'mt-12': !isMobile, 'pt-8': isIOS }">
      <v-row>
        <v-col :cols="navCols" ref="navCol" :class="{ 'pr-2': !isMobile }" v-if="!isMobile">
          <NavigationDrawerVue />
        </v-col>
        <v-col :cols="mainCols" class="pa-6" style="display: flex; position: relative" :style="{
          'min-height': 'calc(100vh - ' + headerHeight + 'px)',
          width: 'calc(100vw - ' + navWidth + 'px)',
        }" :class="{ 'mt-0': isMobile, 'mt-6': !isMobile, 'pl-0': !isMobile, 'px-2': isMobile }">
          <RouterView />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import HeaderVue from "../components/navigation/Header.vue";
import NavigationDrawerVue from "../components/navigation/NavigationDrawer.vue";
import { Capacitor } from "@capacitor/core";

export default {
  name: "mainRoot",

  data() {
    return {
      navWidth: "100",

      activeimage: 1,
    };
  },

  components: {
    HeaderVue,
    NavigationDrawerVue,
  },

  computed: {
    headerHeight() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 245;
        case "sm":
          return 245;
        case "md":
          return 230;
        case "lg":
          return 230;
        case "xl":
          return 230;
        case "xxl":
          return 230;
        default:
          return undefined;
      }
    },
    mainCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return undefined;
        case "lg":
          return undefined;
        case "xl":
          return undefined;
        case "xxl":
          return undefined;
        default:
          return undefined;
      }
    },
    navCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 2;
        case "sm":
          return "auto";
        case "md":
          return "auto";
        case "lg":
          return "auto";
        case "xl":
          return "auto";
        case "xxl":
          return "auto";
        default:
          return "auto";
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    isIOS() {
      if (Capacitor.getPlatform() == 'ios') {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    "$store.state.collapseNavBar"() {
      if (this.$store.state.collapseNavBar == 0) {
        setTimeout(() => {
          this.setWidth();
        }, 500);
      } else {
        this.setWidth();
      }
    },
  },

  methods: {
    setWidth() {
      try {
        let elem = this.$refs.navCol;

        if (!elem) {
          this.navWidth = "100";
        }

        this.navWidth = Math.ceil(elem.$el.getBoundingClientRect().width + 20);
      } catch { }
    },
  },

  mounted() {
    window.addEventListener("resize", (event) => this.setWidth());

    setTimeout(() => {
      this.setWidth();
    }, 200);
  },
};
</script>
